import { Injectable } from '@angular/core';

@Injectable()
export class AproposService {

  private description: string;
  
  constructor() { }

  public getDescriptionDefault(): any{
      return this.description = "Actuellement étudiant en 2ème année Master Qualité du Logiciel à FSDM Fès. \n" +
        "Au  cours  de  mon  cursus,  j’ai  pu  acquérir  de  bonnes  connaissances  en " + 
        " informatique  qui  sont  validés  par  des  projets  et  j’essaye  toujours  de  les  améliorer. " + 
        "Durant ma formation en master MQL,  j’ai appris de nouvelles technologies en systèmes " + 
        "d’information qui m’ont poussé à m’intéresser aux  technologies JavaEE  (Hibernate, JPA, " + 
        "Spring 4, Struts 2, JSF2), le développement des tests unitaires d’intégration (JUnit 5), " + 
        "les  nouvelles  technologies  (Nodejs,  Angular4,  Ionic  3),  ainsi  qu’aux  technologies " + 
        "Mainframe (Cobol, MVS).";
  }

}



// WEBPACK FOOTER //
// C:/Users/Yassine/Desktop/gestion-stagiaires/src/app/apropos/apropos.service.ts